import sum from "lodash/sum";

import { Currency } from "common/generator/components/buy-button-defaults";
import { RequestedInAppPurchaseV2, ShippingAddress, BaseRowIndex } from "common/firebase-function-types";
import { fullUrlFor3dsRedirect } from "./stripe-api";

export type BuyScreenTransactionItem = Readonly<{
    buttonID: string;
    name: string;
    sku: string | number;
    rowIndex: BaseRowIndex | undefined;
    description: string | undefined;
    image: string | undefined;
    price: number;
}>;

type BuyScreenTransactionBase = Readonly<{
    appID: string;
    items: readonly BuyScreenTransactionItem[];
    currency: Currency;
}>;

export type BuyScreenTransactionBootstrap = BuyScreenTransactionBase & {
    withShipping: boolean;
    showStripeLogo: boolean;
};

export type BuyScreenBillingInfo = Readonly<{
    name: string;
    email: string;
    paymentMethodID: string;
    idempotencyKey: string;
    shippingAddress: ShippingAddress | undefined;
    shippingPhone: string | undefined;
}>;

export type BuyScreenPendingTransaction = BuyScreenTransactionBase & BuyScreenBillingInfo;

function convertTransactionItemToRequestItem(
    txnItem: BuyScreenTransactionItem
): { buttonID: string; productSKU: string | number; rowIndex?: BaseRowIndex } {
    const { buttonID, sku: productSKU, rowIndex } = txnItem;
    return { buttonID, productSKU, rowIndex };
}

export function convertBuyScreenTransactionToRequestedInAppPurchaseV2(
    transaction: BuyScreenPendingTransaction,
    testMode: boolean
): RequestedInAppPurchaseV2 {
    const {
        appID,
        paymentMethodID,
        idempotencyKey,
        name: billingName,
        email: receiptEmail,
        shippingAddress,
        shippingPhone,
        items,
    } = transaction;
    return {
        version: 2,
        appID,
        paymentProcessor: "stripe",
        processorPayload: {
            paymentMethodID,
            idempotencyKey,
            tdsRedirect: fullUrlFor3dsRedirect(),
        },
        billingName,
        receiptEmail,
        shippingAddress,
        shippingPhone,
        items: items.map(convertTransactionItemToRequestItem),
        testMode,
    };
}

export function totalPriceForItems(items: readonly BuyScreenTransactionItem[]): number {
    return sum(items.map(({ price }) => price));
}
